<template>
    <div class="flex-column-header">
        <slot></slot>
    </div>
</template>
<script>
export default {
}
</script>
<style scoped lang="scss">
.flex-column-header {
    flex: none;
}
</style>